import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}inspections/`;

const createInspectionNote = (id,params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/inspection_notes`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchInspectionNote = (inspectionId,id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${inspectionId}/inspection_notes/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchInspectionNotes = (id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/inspection_notes`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateInspectionNote = (inspectionId,id,params) => new Promise(((resolve, reject) => {
	const endpointURL = `${apiURL}${inspectionId}/inspection_notes/${id}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteInspectionNote = (inspectionId,id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${inspectionId}/inspection_notes/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

export default {
	createInspectionNote,
	fetchInspectionNote,
	fetchInspectionNotes,
	updateInspectionNote,
	deleteInspectionNote
};



// WEBPACK FOOTER //
// ./src/api/inspection_notes.js